export function applyBalanceResponse(data, target) {
  if (!data?.currencies) {
    return false
  }

  const userCurrency = data.user_currency
  const balanceValue = data.currencies[userCurrency] || 0
  const [wholePart, fractionalPart] = balanceValue.toString().split(".")

  target.balance = parseInt(wholePart, 10) || 0
  target.balanceCents = (fractionalPart || "00").padEnd(2, "0").substring(0, 2)
  target.balanceCurrencies = data.currencies

  if (target.currency) {
    target.currency.name = userCurrency
  }

  if (typeof target.updateCurrencySymbol === "function") {
    target.updateCurrencySymbol(userCurrency)
  }

  return true
}
